<template>
  <div id="training" class="fixed-content">
    <page-section title="Formation"
                  :header="require('@/assets/results.jpg')">
      <div class="row">
        <div class="col-xs-12 col-md-8 col-md-push-2">
          <p class="introduction text-justify">
            La formation des professionnels de santé en charge de la pose et des
            manipulations des lignes associées aux dispositifs invasifs permet d’améliorer
            les pratiques, et de prévenir les infections liées à un cathéter.
          </p>
          <p class="introduction text-justify">
            La SPIADI propose des supports de formation sous différentes formes, ainsi
            qu'une journée de formation annuelle.
          </p>
        </div>
      </div>
      <div class="row">
        <div v-for="(v, k) in sources"
             :key="`source-${k}`"
             class="col-xs-12 col-sm-6 col-lg-3 text-center">
          <a role="button"
             @click="$router.push(v.route)"
              class="btn btn-lg btn-block action-btn"
             :class="`btn-${v.style}`">
            <span class="icon-container">
              <svg-icon :icon="v.icon" color="white"/>
            </span>
            {{ v.title }}
            <div><small>{{ v.subtitle }}</small></div>
          </a>
        </div>
      </div>
    </page-section>
  </div>
</template>

<script>
import pageSection from '@/components/pagesection'
import svgIcon from '@/sui/components/svgIcon'

export default {
  name: 'program',

  data () {
    return {
      sources: {
        missionday: {
          icon: 'speaker',
          style: 'reaInfADI',
          route: 'missionday',
          title: 'Journée Nationale',
          subtitle: ''
        },

        techSheets: {
          icon: 'list',
          style: 'techSheet',
          route: 'tools?tab=0',
          title: 'Fiches Techniques',
          subtitle: ''
        },

        tools: {
          icon: 'youtube',
          style: 'reaExplaur',
          route: 'tools?tab=1',
          title: 'Outils Pédagogiques',
          subtitle: ''
        },

        training: {
          icon: 'file',
          style: 'alone',
          route: 'tools?tab=2',
          title: 'Supports de Formation',
          subtitle: ''
        }
      }
    }
  },

  components: {
    'page-section': pageSection,
    'svg-icon': svgIcon
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.action-btn {
  margin-top: 4rem;
  margin-bottom: 4rem;
  font-size: 160%;
  small {
    font-size: 50%;
  }
  .icon-container {
    .svg-icon {
      width: 15%
    }
  }
}

.action-btn:last-child {
  margin-bottom: 0rem;
}

.introduction {
  font-size: 140%;
}
</style>
